import React, { createContext, useMemo, useState } from 'react'

const IdContext = createContext({
  id: null,
  setId: () => {},
  uid: null,
  setUid: () => {},
})

export const IdContextProvider = ({ children }) => {
  const [id, setId] = useState(null)
  const [uid, setUid] = useState(null)

  const contextValue = useMemo(
    () => ({
      id,
      setId,
      uid,
      setUid,
    }),
    [id, setId, uid, setUid]
  )

  return <IdContext.Provider value={contextValue}>{children}</IdContext.Provider>
}

export default IdContext
